import React, {useMemo, memo} from 'react';
import {Props} from './ac-avatar.proptypes';
import clsx from 'clsx';

// Imports => Constants
import {TYPES} from '@asdf-constants';

// Imports => Utilities
import {AcIsObject} from '@asdf-utils';

// Imports => Atoms
import {AcIcon} from '@asdf-atoms/ac-icon';
import {AcImage} from '@asdf-atoms/ac-image';

const _CLASSES = {
  MAIN: 'ac-avatar',
  THEME: {
    DEFAULT: 'ac-avatar--default',
    OMEGA: 'ac-avatar--omega',
    ALPHA: 'ac-avatar--alpha',
    BETA: 'ac-avatar--beta',
    CHARLIE: 'ac-avatar--charlie',
    ECHO: 'ac-avatar--echo',
  },
  AVATAR: {
    WRP: 'ac-avatar__avatar-wrp',
    MAIN: 'ac-avatar__avatar',
  },
};

const AcAvatar = memo(({avatar = null, theme = 'default', className, ...rest}) => {
  const getAvatarClassNames = useMemo(() => {
    return clsx(_CLASSES.AVATAR.MAIN);
  }, []);

  const getAvatarWrpClassNames = useMemo(() => {
    return clsx(_CLASSES.AVATAR.WRP);
  }, []);

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN, theme && _CLASSES.THEME[theme.toUpperCase()], className);
  }, [className, theme]);

  const getSizeInlineStyle = useMemo(() => {
    if (!AcIsObject(avatar)) return null;

    return {
      height: avatar.size ? `${avatar.size}rem` : '8rem',
      fontSize: avatar.size ? `${avatar.size}rem` : '8rem',
    };
  }, [avatar]);

  const renderAvatar = useMemo(() => {
    if (!AcIsObject(avatar)) return null;

    const {type, value} = avatar;
    let result = null;

    switch (type) {
      case TYPES.ICON:
        result = <AcIcon icon={avatar.value} className={getAvatarClassNames} />;
        break;

      case TYPES.STRING:
        result = (
          <div
            dangerouslySetInnerHTML={{
              __html: avatar.value,
            }}
            className={getAvatarClassNames}
          />
        );
        break;

      case TYPES.IMAGE:
        result = (
          <AcImage source={avatar.value} type={TYPES.BACKGROUND} className={getAvatarClassNames} />
        );
        break;

      default:
    }

    return result;
  }, [avatar]);

  return (
    <div className={getMainClassNames} {...rest}>
      <div className={getAvatarWrpClassNames} style={getSizeInlineStyle}>
        {renderAvatar}
      </div>
    </div>
  );
});

AcAvatar.displayName = 'AcAvatar';
AcAvatar.propTypes = Props;

export {AcAvatar};
export default AcAvatar;
